import React from "react";
import CSItem from "./item";

const CrossSellItems = ({ data, setItems }) => {
    const freeItems = data
        .filter((item) => item.accessory_type === "free")
        .sort((first, second) => first.position - second.position);

    const frequentlyItems = data
        .filter((item) => item.accessory_type === "frequently_bought" && item.shopify_product)
        .sort((first, second) => first.position - second.position);
    return (
        <div className="w-full pb-4 pt-7 px-1.5 border-b lg:px-0 lg:py-2.5">
            {freeItems.map((item) => (
                <CSItem item={item} key={item?.id} setItems={setItems} isFree />
            ))}
            {frequentlyItems.map((item) => (
                <CSItem item={item} key={item?.id} setItems={setItems} />
            ))}
        </div>
    );
};

export default CrossSellItems;
